import React from 'react';
import './styles.css';

const NotFoundPage = () => {
  return (
    <>NOT FOUND</>
  );
};

export default NotFoundPage;